<template>
  <div id="app">
    <div class="close-web" >网站关闭中......</div>
  </div>
</template>

<script>
export default {
  name: "App",
  data(){
    return {

    }
  },
  created(){
    // else{
      // db.post(db.config.getWebInfoUrl).then(res=>{
      //   if(res.data.ifclose==1){
      //     router.push({name: 'homeIndex'});
      //     return  false
      //   }
      // })

    // }
    
  }
};
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  /* text-align: center; */
  /* color: #2c3e50; */
  /* margin-top: 60px; */
}
.close-web{
  /* margin:0 auto */
  font-size: 24px;
  margin-top: 300px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/friend.vue